import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { getPostes } from '../../../../services/RHService/PostService';
import { updatePoste } from '../../../../services/RHService/PostService';
import { deletePoste } from '../../../../services/RHService/PostService';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";
const PostList = ({ startLoading, stopLoading }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [data,] = useState([]);
    // const [selectedPost, setSelectedPost] = useState(null);
    const [posts, setPosts] = useState([]);
    const [nomPost, setNomPost] = useState("");
    const [idPost, setIdPost] = useState("");
    const [nb_hrs_mois, setNb_hrs_mois] = useState("");

    //afficher les information par defaut dans le Model
    const handleShow = (post) => {
        console.log(post)
        setNomPost(post.nomPost);
        setIdPost(post.id);
        setNb_hrs_mois(post.nb_hrs_mois);
        setShow(true);
    };
    //afficher les infos dans le tableau
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        startLoading();
        getPostes(getCurrentUserId()).then((response) => {
            console.log(response)
            if (response.data.success) {
                setPosts(response.data.success);
            } else {
                setPosts([])
            }
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
            stopLoading();
        })

    };
    //archiver poste sweetalert
    const handleDelete = async (postID) => {
        await deletePoste(postID, setPosts);
    };
    //update Post
    const handleUpdate = async (event) => {
        event.preventDefault();
        try {
            let formData = {
                isPost: idPost,
                nomPost: nomPost,
                nb_hrs_mois: nb_hrs_mois,
                idUserCreation: getCurrentUserId()
            }
            updatePoste(formData).then((response) => {
                console.log("updatePoste", response)
                fetchData();
                handleClose();
            }).catch((e) => {
                console.log(e)
            })

        } catch (error) {
            alert(error.message);
        }

    };

    //pagination
    const options = {
        sizePerPage: 5,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        paginationPosition: "bottom",
    };
    //colonnes de tableau
    const columns = [
        // {
        //     dataField: 'id_pos', text: '#',
        //     formatter: (cell, row, rowIndex, formatExtraData) => {
        //         return rowIndex + 1;
        //     }
        // },
        { dataField: 'nomPost', text: 'Nom de post' },
        { dataField: 'nbHrsMois', text: 'Nombre heure/mois' },

        {
            dataField: 'actions', text: 'Actions', formatter: (cell, row) => {
                return (
                    <ul class="nav nav-pills ml-auto">
                        <li class="nav-item dropdown" >
                            <div class="nav-link " data-toggle="dropdown" >
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div class="dropdown-menu" >
                                <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} onClick={() => { handleShow(row) }}>
                                    <i class="fa-solid fa-pen m-2" ></i>Edit
                                </Button>
                                <Button style={{ "background-color": "white", "color": "black", "border-color": "transparent" }} onClick={() => { handleDelete(row.id) }}>
                                    <i class="fa-solid fa-trash m-2"></i>Remove
                                </Button>
                            </div>
                        </li>
                    </ul>
                );
            }
        }
    ];
    const onChangeNamePostHandler = (event) => {
        setNomPost(event.target.value);
    };
    const onChangeNb_hrs_moisHandler = (event) => {
        setNb_hrs_mois(event.target.value);
    };
    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
            >
                {
                    props => (
                        <div>
                            <Modal show={show} onHide={handleClose} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Modifier les informations</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="show-grid">
                                    <Form onSubmit={handleUpdate}>
                                        <Container>
                                            <Row>
                                                <Col xs={12} md={12} >
                                                    <Form.Group className="mb-3 " controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Nom de post</Form.Label>
                                                        <div className="form-group">
                                                            <label htmlFor="inputName">Post</label>
                                                            <input
                                                                placeholder="Ajouter libellé "
                                                                onChange={onChangeNamePostHandler}
                                                                type="text"
                                                                id="inputName"
                                                                value={nomPost}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <div className="form-group">
                                                        <label htmlFor="inputName">Nombre d'heures/mois</label>
                                                        <input
                                                            placeholder="Ajouter Nombre d'heures par mois "
                                                            onChange={onChangeNb_hrs_moisHandler}
                                                            value={nb_hrs_mois}
                                                            type="number"
                                                            id="inputName"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </Col>

                                            </Row>
                                        </Container>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Fermer
                                    </Button>
                                    <Button variant="dark" onClick={handleUpdate}>
                                        Modifier
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <div className="content-header">
                                <div className="container-fluid">
                                    <div className="row mb-2">
                                        <div className="col-sm-6">
                                            <h1 className="m-0">Liste des postes</h1>
                                        </div>
                                        <div className="col-sm-6">
                                            <ol className="breadcrumb float-sm-right">
                                                <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li>
                                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                                <li className="breadcrumb-item active">Liste des postes</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="container-fluid">
                                <div class="card card-dark">
                                    <div class="card-body">
                                        <h5 class="card-title">Ajouter un poste</h5>

                                        <Link to="/addpost" >
                                            <button
                                                class="btn btn-dark float-right"
                                            >
                                                {" "}
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </Link>


                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-12">
                                        <div class="card">
                                            <div class="card-header">
                                                <h3 class="card-title">Liste des postes</h3>
                                            </div>
                                            <BootstrapTable keyField='id' data={posts} columns={columns} pagination={paginationFactory(options)} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </ToolkitProvider>
        </div>
    );
}
export default withLoader(PostList);